// extracted by mini-css-extract-plugin
export default {"titleRow":"MT_3dTod6VwkK29U1g0p","title":"R8qYGTfFoqumgbeieGQ7","description":"CYG61nM27rnBFqRcPKlX","contentContainer":"DmKKI8Ub0fqbgKxW2v2O"};